import { render, staticRenderFns } from "./districtsAdd.vue?vue&type=template&id=759f06cd&scoped=true"
import script from "./districtsAdd.vue?vue&type=script&lang=js"
export * from "./districtsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f06cd",
  null
  
)

export default component.exports